import React from 'react'
import CheckoutProduct from './CheckoutProduct'
import './Order.css'
import moment from 'moment'
import CurrencyFormat from "react-currency-format";

export default function Order({order}) {
  return (
    <div className='order'>
        <h2>Order</h2>
        <p>{moment.unix(order.data.created).format("MMMM Do YYYY, h:mmma")}</p>
         <p className='order_id' >
             <small>{order.id}</small>
         </p>
         {order.data.basket?.map(item =>(
             <CheckoutProduct 
             id={item.id}
             title={item.title}
             price={item.price}
             img={item.img}
             rating={item.rating}
             hidden
             />
         ))}
           <CurrencyFormat
                  renderText={(value) => (
                      <h3 className='order_total' >Order Total: {value} </h3>
                  )}
                  decimalScale={2}
                  value={order.data.amount/100} // Part of the homework
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={"₹"}
                />
    </div>
  )
}
